/* Modulo: Slideshow Editorial — full-bleed one-up slideshow.
   JS owns the index; CSS owns the reveal (zero CLS). Color-plane wipe OR
   cross-fade, paired arrows, dynamic dots, keyboard, pointer-swipe.
   Lazy-init, reduced-motion aware, aria-live announced, outgoing slide inert,
   idempotent init (theme-editor re-render safe). Vanilla IIFE. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var REDUCE = !!(mq && mq.matches);
  if (mq && mq.addEventListener) {
    mq.addEventListener('change', function (e) { REDUCE = e.matches; });
  }

  /* Pause-on-hover is only meaningful where hover exists. On touch, a tap emits a
     synthetic mouseenter and there may be no matching mouseleave until the shopper
     taps something else, which stopped autoplay indefinitely after a single tap. */
  var HOVER = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  var SWIPE_THRESHOLD = 50;
  var WIPE_MS = 1150;   /* >= longest plane (1.02s + 0.06s lag) + buffer */
  var FADE_MS = 650;    /* cross-fade / reduced-motion cleanup */

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function setSlideInert(slide, inert) {
    var ctrls = slide.querySelectorAll('a, button');
    for (var i = 0; i < ctrls.length; i++) {
      if (inert) ctrls[i].setAttribute('tabindex', '-1');
      else ctrls[i].removeAttribute('tabindex');
    }
  }

  /* Reduced motion suppresses auto-advance (see start/restart), which is correct and
     matches the rest of the library. But it is completely invisible: a merchant with
     "Reduce motion" on their machine turns autoplay on, watches a hero that never
     rotates, and reasonably concludes the section is broken. Both the arrows and the
     shopper-facing render are fine, so there is nothing to find. Say so, in the theme
     editor only, where the belief is formed. Built with textContent, never innerHTML. */
  function reduceMotionNotice(root, wantsAuto) {
    if (!wantsAuto || !REDUCE) return;
    if (!window.Shopify || !window.Shopify.designMode) return;
    if (root.querySelector('[data-modulo-sle-rm-notice]')) return;

    var note = document.createElement('p');
    note.setAttribute('data-modulo-sle-rm-notice', '');
    note.textContent =
      'Autoplay is paused because "Reduce motion" is turned on in this device\'s ' +
      'accessibility settings. Shoppers without that setting still see the slides ' +
      'rotate. To rotate for them too, turn on "Also rotate for reduced-motion ' +
      'visitors" under Slideshow behavior. Only you can see this note, and only in ' +
      'the theme editor.';
    note.style.cssText =
      'margin:0 0 12px;padding:10px 14px;border-radius:8px;background:#FEF3C7;' +
      'color:#7C2D12;border:1px solid #FCD34D;font-family:system-ui,-apple-system,' +
      'sans-serif;font-size:13px;font-weight:500;line-height:1.45;text-align:left;';
    root.insertBefore(note, root.firstChild);
  }

  function initSlideshow(root) {
    if (root.dataset.moduloSleReady === '1') return;   // idempotent
    root.dataset.moduloSleReady = '1';

    var stage  = root.querySelector('[data-stage]');
    var slides = root.querySelectorAll('[data-slide]');
    var total  = slides.length;
    if (!stage || total < 2) return;   // single slide → static hero, no JS work

    var loop      = root.dataset.loop === '1';
    var autoplay  = root.dataset.autoplay === '1';
    var interval  = (parseInt(root.dataset.interval, 10) || 7) * 1000;
    var transition = root.dataset.transition || 'wipe';

    /* Merchant escape hatch. Reduced motion stops auto-advance by default, which is
       right, but it left merchants with a hero that looked broken and no way out.
       Opting in keeps the rotation while the motion stays genuinely reduced: the CSS
       @media block strips every transform (plane wipe, ken-burns, inner slide-ups)
       and simple() forces the instant path, so slides cross-fade rather than move. */
    var allowReducedAuto = root.dataset.autoplayReducedMotion === '1';
    function autoBlocked() { return REDUCE && !allowReducedAuto; }

    reduceMotionNotice(root, autoplay && !allowReducedAuto);

    function simple() { return REDUCE || transition === 'fade'; }

    var dotsHost   = root.querySelector('[data-dots]');
    var counterCur = root.querySelector('[data-counter-cur]');
    var liveRegion = root.querySelector('[data-live]');
    var prevBtns   = root.querySelectorAll('[data-prev]');
    var nextBtns   = root.querySelectorAll('[data-next]');

    var current = 0;
    var animating = false;
    var timer = null;
    var wipeTimer = null;
    var dots = [];

    for (var s = 0; s < total; s++) {
      if (s !== current) setSlideInert(slides[s], true);
    }

    /* Lazy image hydration — non-first slides ship with data-src/-srcset and make
       no request; promote the current slide + its neighbours so distant slides
       never fetch their full-bleed backgrounds on initial load. */
    function hydrate(slide) {
      if (!slide) return;
      var imgs = slide.querySelectorAll('img[data-src]');
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (im.dataset.srcset) im.srcset = im.dataset.srcset;
        if (im.dataset.sizes) im.sizes = im.dataset.sizes;
        im.src = im.dataset.src;
        im.removeAttribute('data-src');
        im.removeAttribute('data-srcset');
        im.removeAttribute('data-sizes');
      }
    }
    function hydrateAround(i) {
      hydrate(slides[i]);
      var nx = i + 1, pv = i - 1;
      if (loop) { nx = nx % total; pv = (pv + total) % total; }
      if (nx < total) hydrate(slides[nx]);
      if (pv >= 0) hydrate(slides[pv]);
    }

    function buildDots() {
      if (!dotsHost) return;
      while (dotsHost.firstChild) dotsHost.removeChild(dotsHost.firstChild);
      dots = [];
      for (var i = 0; i < total; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'modulo-sle__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1) + ' of ' + total);
        if (i === 0) b.setAttribute('aria-current', 'true');
        (function (idx) {
          b.addEventListener('click', function () { stop(); goTo(idx); restart(); });
        })(i);
        dotsHost.appendChild(b);
        dots.push(b);
      }
    }

    function announce() {
      if (!liveRegion) return;
      var title = slides[current].getAttribute('data-title') || '';
      liveRegion.textContent = 'Slide ' + (current + 1) + ' of ' + total + (title ? ': ' + title : '');
    }

    function toggle(el, off) { off ? el.setAttribute('disabled', '') : el.removeAttribute('disabled'); }

    function syncChrome() {
      for (var i = 0; i < dots.length; i++) {
        if (i === current) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
      if (counterCur) counterCur.textContent = pad2(current + 1);
      if (!loop) {
        for (var p = 0; p < prevBtns.length; p++) toggle(prevBtns[p], current <= 0);
        for (var n = 0; n < nextBtns.length; n++) toggle(nextBtns[n], current >= total - 1);
      }
    }

    function goTo(index) {
      var target = loop
        ? ((index % total) + total) % total
        : Math.max(0, Math.min(total - 1, index));
      if (target === current || animating) return;

      var outgoing = slides[current];
      var incoming = slides[target];
      var quick = simple();

      hydrate(incoming);            // request the incoming image as the transition starts
      animating = true;

      outgoing.classList.add('is-leaving');
      outgoing.classList.remove('is-current');
      setSlideInert(outgoing, true);

      incoming.classList.add('is-current');
      setSlideInert(incoming, false);
      current = target;
      syncChrome();
      announce();
      hydrateAround(current);       // preload the new neighbour

      if (!quick) {
        stage.classList.remove('is-wiping');
        void stage.offsetWidth;            // restart the wipe keyframe
        stage.classList.add('is-wiping');
      }

      clearTimeout(wipeTimer);
      wipeTimer = setTimeout(function () {
        outgoing.classList.remove('is-leaving');
        stage.classList.remove('is-wiping');
        animating = false;
      }, quick ? FADE_MS : WIPE_MS);
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function bind(nl, fn) {
      for (var i = 0; i < nl.length; i++) {
        nl[i].addEventListener('click', function (e) { e.preventDefault(); fn(); });
      }
    }
    bind(prevBtns, function () { stop(); prev(); restart(); });
    bind(nextBtns, function () { stop(); next(); restart(); });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); stop(); prev(); restart(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); stop(); next(); restart(); }
    });

    var sx = 0, dx = 0, drag = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button')) return;
      if (e.button !== undefined && e.button !== 0) return;
      drag = true; sx = e.clientX; dx = 0; stop();
    });
    stage.addEventListener('pointermove', function (e) { if (drag) dx = e.clientX - sx; });
    function endDrag() {
      if (!drag) return;
      drag = false;
      if (Math.abs(dx) > SWIPE_THRESHOLD) { dx < 0 ? next() : prev(); }
      dx = 0; restart();
    }
    stage.addEventListener('pointerup', endDrag);
    stage.addEventListener('pointercancel', endDrag);
    stage.addEventListener('pointerleave', function () { if (drag) endDrag(); });

    function start() {
      if (!autoplay || autoBlocked() || total < 2) return;
      stop();
      timer = setInterval(next, interval);
    }
    function stop()    { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { if (autoplay && !autoBlocked()) setTimeout(start, 250); }

    if (autoplay) {
      if (HOVER) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', start);
      }
      // Focus pausing stays on every device: it is recoverable (focusout resumes)
      // and a keyboard user reading a slide must not have it swapped underneath them.
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
    }
    // let shopify:section:unload clear the interval instead of leaving it firing
    // against a detached subtree after the theme editor removes the section
    root.moduloSleStop = stop;

    buildDots();
    syncChrome();
    hydrateAround(current);       // first slide is already real-src; preload slide 2
    start();
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-sle]', initSlideshow);
    } else {
      var els = document.querySelectorAll('[data-modulo-sle]');
      for (var i = 0; i < els.length; i++) initSlideshow(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* The theme editor replaces a section's markup on every settings change. Without
     this the fresh DOM is never initialised, so autoplay (and arrows, dots and
     keyboard) are dead for the rest of the editor session — which is exactly where
     a merchant turns autoplay on and concludes it does not work. The dataset guard
     in initSlideshow makes re-running safe. */
  document.addEventListener('shopify:section:load', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    if (scope.matches && scope.matches('[data-modulo-sle]')) initSlideshow(scope);
    var els = scope.querySelectorAll('[data-modulo-sle]');
    for (var i = 0; i < els.length; i++) initSlideshow(els[i]);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    var els = scope.querySelectorAll('[data-modulo-sle]');
    for (var i = 0; i < els.length; i++) {
      if (typeof els[i].moduloSleStop === 'function') els[i].moduloSleStop();
    }
    if (scope.matches && scope.matches('[data-modulo-sle]') && typeof scope.moduloSleStop === 'function') {
      scope.moduloSleStop();
    }
  });
})();
